<script setup lang="ts">
  // `recruiter`: the analysed CV belongs to someone else (ATS manual add).
  withDefaults(defineProps<{ title?: string; recruiter?: boolean }>(), { title: 'Je postule', recruiter: false })

  const theme = useCareerTheme()
  const primaryStyle = computed(() => (theme.value.primary ? { color: theme.value.primary } : undefined))

  // Explain the longer wait without restarting the progress animation.
  const RELAY_DELAY = 10000
  const relayed = ref(false)
  let relayTimer: ReturnType<typeof setTimeout> | null = null

  onMounted(() => {
    relayTimer = setTimeout(() => (relayed.value = true), RELAY_DELAY)
  })
  onUnmounted(() => {
    if (relayTimer) clearTimeout(relayTimer)
  })
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-10 py-16 text-center">
    <h1 class="font-special text-3xl font-bold" :style="primaryStyle">{{ title }}</h1>
    <p class="text-sm" v-if="relayed">
      {{ recruiter ? 'Nous lisons les diplômes, les permis et les langues' : 'Nous lisons vos diplômes, vos permis et vos langues' }} - encore
      quelques secondes.
    </p>
    <p class="text-sm" v-else>
      {{ recruiter ? 'Analyse du CV en cours, veuillez patienter…' : 'Analyse de votre CV en cours, veuillez patienter…' }}
    </p>
    <Loading size="10x" :color="theme.primary || undefined" />
  </div>
</template>
